import * as React from "react";
import { SVGProps } from "react";

const SvgLiveTemperature = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M23.867 19.333c-.81 0-1.467.639-1.467 1.426v5.062c-1.864.64-3.2 2.37-3.2 4.401 0 2.578 2.149 4.667 4.8 4.667s4.8-2.09 4.8-4.667c0-2.032-1.336-3.76-3.2-4.4v-5.063c0-.787-.657-1.426-1.467-1.426h-.266Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.2 14.278c0-2.363 1.97-4.278 4.4-4.278h.8c2.43 0 4.4 1.915 4.4 4.278v9.721c1.943 1.42 3.2 3.679 3.2 6.223C32 34.518 28.418 38 24 38s-8-3.482-8-7.778c0-2.544 1.257-4.804 3.2-6.223v-9.721Zm8 .082v10.472c1.913 1.076 3.2 3.087 3.2 5.39 0 3.437-2.865 6.222-6.4 6.222s-6.4-2.785-6.4-6.222c0-2.303 1.287-4.314 3.2-5.39V14.36c0-1.575 1.313-2.852 2.933-2.852h.534c1.62 0 2.933 1.277 2.933 2.852ZM10 7H7v8h3v-5h5V7h-5Zm0 26H7v8h8v-3h-5v-5Zm28 0h3v8h-8v-3h5v-5Z"
      fill="#fff"
    />
    <circle cx={36.5} cy={11.5} r={4.5} fill="#fff" />
  </svg>
);

export default SvgLiveTemperature;
